export default __webpack_public_path__ + "static/media/library.af0bbe34.svg";